import React from "react";
import {components} from 'react-select';
import FormikSearchSelector from "gui/components/formikSearchSelector/FormikSearchSelector";
import {IPlaceDetails, IPredictionFormatted} from 'data/interfaces/products';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import styles from './AutoCompletePlacesSelector.module.scss';


export interface IAutoCompletePlacesSelectorProps {
  label: string;
  field?: any;
  form?: any;
  queryPlaces: (query: string) => Promise<IPredictionFormatted[]>;
  queryPlaceDetails: (placeId: string) => Promise<IPlaceDetails>;
}


const MenuList = props => (
  <components.MenuList {...props}>
    {props.children}
    <img
      alt="Powered by Google"
      src="/img/powered_by_google_on_white.png"
      referrerPolicy="no-referrer"
      title="Powered by Google"
      loading="lazy"
    />
  </components.MenuList>
);

const NoOptionsMessage = () => (
  <p>
    חפש/י לפי בית מלון
  </p>
);

const DropdownIndicator = props => {
  return (<SearchRoundedIcon className={styles.searchIcon}/>)
}


const AutoCompletePlacesSelector = (props: IAutoCompletePlacesSelectorProps) => {
  return (
    <FormikSearchSelector
      options={props.field.value ? [{label: props.field.value.name, value: props.field.value}] : []}
      promiseOptions={props.queryPlaces}
      onChange={(async (place: IPredictionFormatted) => {
        if (place) {
          await props.field.onChange({
            target: {
              name: props.field.name,
              value: {
                ...place,
                loading: true,
              } as IPlaceDetails & IPredictionFormatted & { postalCode: string, loading?: boolean },
            },
          });
          //  return null;
          await props
            .queryPlaceDetails(place.place_id)
            .then(async (placeDetails) => {
              const postalCodeComponent = (placeDetails.address_components || []).find(address_component => address_component.types.find(type => type === "postal_code"));
              if (placeDetails.photos && placeDetails.photos.length > 0) {
                if ('imagePick' in props.form.initialValues) {
                  await props.field.onChange({
                    target: {
                      name: 'imagePick',
                      //value: {
                      //  [placeDetails.photos[0].photo_reference]: 0
                      //},
                      value: [placeDetails.photos[0].photo_reference],
                    },
                  });
                }
              }
              await props.field.onChange({
                target: {
                  name: props.field.name,
                  value: {
                    ...placeDetails, ...place,
                    postalCode: postalCodeComponent ? postalCodeComponent.long_name : '',
                  } as IPlaceDetails & IPredictionFormatted & { postalCode: string },
                },
              });
            });
        } else {
          await props.field.onChange({
            target: {
              name: props.field.name,
              value: undefined,
            },
          });
        }
      })}
      components={{MenuList, NoOptionsMessage, DropdownIndicator}}
      {...props}
    />
  );
};

AutoCompletePlacesSelector.defaultProps =
  {
    queryPlaces: () => Promise.resolve(),
    queryPlaceDetails: () => Promise.resolve(),
  };

export default AutoCompletePlacesSelector;
